export default __webpack_public_path__ + "static/c3-popup-zomer-2024-fd4b86629c65675e0899d64af8fa43c8.png";